// messageTime — pure time affordances for the chat surface.
//
// A pure, total, clock-free helper the transcript's live affordances render
// through; the IMPURE clock (the ticking interval) lives in the components
// (DraftingIndicator). Per-message relative time uses app/recency.ts, the one
// app-wide formatter (G14).
//
//   • `formatElapsed(ms)` → "M:SS" for the active turn's elapsed clock.

export { formatElapsed };

// The active turn's elapsed clock as "M:SS" (e.g. "2:14", "0:05"). Negative
// input (never expected) clamps to "0:00" rather than showing a minus sign.
const formatElapsed = (ms: number): string => {
    const totalSeconds = Math.max(0, Math.floor(ms / 1000));
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds.toString().padStart(2, "0")}`;
};
